import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstCr1: [],
		cr1: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		rgbPicker: { r: 0, g: 0, b: 0 },
		lastUpdatedRegister: null
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getCr1(state) {
			return state.cr1
		},
		getCr1cor(state) {
			return state.cr1.cr1cor
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
		getRgbPicker(state) {
			return state.rgbPicker
		},
	},
	mutations: {
		set(state, cr1) {
			state.cr1 = cr1
			if (cr1)
				state.update = true
		},
		setRgbPicker(state, { r, g, b }) {
			state.rgbPicker = { r, g, b }
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cr1 = null
			state.rgbPicker = { r: 0, g: 0, b: 0 }
		},
		setParamsDataTable(state, payload) {
			state.lstCr1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setCr1(state, cr1) {
			state.cr1 = cr1
		},
		setLstCr1(state, lstCr1) {
			state.lstCr1 = lstCr1
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setCr1numero(state, cr1numero) {
			state.cr1.cr1numero = cr1numero
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, cr1cor) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/Products/Color/Find/${cr1cor}`)
				.then(response => {
					let cr1 = Utils.ValidateAxiosResponse(response.data);
					commit("set", cr1)

					if (cr1?.rgbColor)
						commit("setRgbPicker", cr1.rgbColor)
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				});
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate)
				return await dispatch("update")
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			const cr1 = await this._vm.$axios.post("/Products/Color/Insert", getters.getCr1)
				.then(response => {
					let cr1 = Utils.ValidateAxiosResponse(response.data)
					commit('setLastUpdatedRegister', cr1);
					commit("setCr1", null)
					return cr1
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return cr1
		},
		async update({ commit, getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			const cr1 = await this._vm.$axios.put("/Products/Color/Update", getters.getCr1)
				.then(response => {
					let cr1 = Utils.ValidateAxiosResponse(response.data)
					commit('setLastUpdatedRegister', cr1);
					commit("setCr1", null)
					return cr1
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return cr1
		},
		async delete({ getters, dispatch }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
			await this._vm.$axios.delete(`/Products/Color/Delete/${getters.getCr1cor}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data);
					router.push("/oryxpdv/cores")
					return true
				})
				.catch((error) => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList({ commit, getters, dispatch }) {
			commit("setLoading", true)
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Pesquisando lista de cores", indeterminate: true },
				{ root: true },
			)
			commit("initForm")
			let payload = await this._vm.$axios.get(`/Products/Color/FindList`)
				.then(response => {
					let lstCr1 = Utils.ValidateAxiosResponse(response.data);
					commit("setLstCr1", lstCr1)
					commit("setHasNext", lstCr1.length > getters.getItemsPerPage)
					return true
				}).catch(error => {
					commit("setLstCr1", [])
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				})	
			commit("setLoading", false)
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios.get(`/Products/Color/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					commit("setParamsDataTable", payload)
					return true
				})
				.catch((error) => {
					commit("setLstCr1", [])
					commit("setSearch", "")
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});
			commit("setLoading", false)
			return payload
		},
		async getArgbColor({ commit, getters, dispatch }) {
			const { r, g, b } = getters.getRgbPicker
			const rgbColorBody = {
				red: r,
				green: g,
				blue: b
			}

			await this._vm.$axios.post("/Products/Color/GetArgbColor", rgbColorBody)
				.then(response => {
					const { win32colorCode } = Utils.ValidateAxiosResponse(response.data);

					if (win32colorCode || win32colorCode == 0)
						commit("setCr1numero", win32colorCode)

					return true
				})
				.catch((error) => {
					dispatch("parameters/showSnackBar", {
						show: true,
						timeout: 3000,
						text: error.message,
						color: "red"
					}, { root: true })
					return false
				});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async saveCr1Image({ dispatch }, { cr1cor, image }) {
			const formData = new FormData()
			formData.append("image", image)

			let payload = await this._vm.$axios.post("/Products/Image/Save/CR1/" + cr1cor, formData)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch("parameters/openDialog", { titleText: "Erro", titleColor: "red", text: error.message }, { root: true })
					return null
				});
			return payload
		},
		async deleteCr1Image({ dispatch }, cr1cor) {
			let payload = await this._vm.$axios.delete("/Products/Image/Delete/CR1/" + cr1cor)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch("parameters/openDialog", { titleText: "Erro", titleColor: "red", text: error.message }, { root: true })
					return null
				});
			return payload
		},
	}
}